import React, { useCallback, useMemo } from 'react';
import { PERMISSIONS } from 'constants/permissions';
import { useAccessControl } from 'components/common/accessControl/useAccessControl';

export const useTaskDetails = () => {
  const { hasAccess } = useAccessControl();
  const [activeTab, setActiveTab] = React.useState<string>('General');

  const onChange = useCallback((key: string) => {
    setActiveTab(key);
  }, []);

  const tabOptions = useMemo(() => {
    const options = [];
    if (hasAccess(PERMISSIONS.tasks.tabs.general.read)) {
      options.push(`General`);
    }
    if (hasAccess(PERMISSIONS.tasks.tabs.attachment.read)) {
      options.push(`Attachments`);
    }
    if (hasAccess(PERMISSIONS.tasks.tabs.logs.read)) {
      options.push(`Logs`);
    }
    return options;
  }, [hasAccess]);
  return {
    onChange,
    tabOptions,
    activeTab,
  };
};
